export default __webpack_public_path__ + "static/media/sign_up_middle_down3.2f62b673.png";